module.exports = __webpack_public_path__ + "static/media/flag_us.237be2db.svg";